import { PartAvailability } from '@/entities/PartAvailability';
import URI from 'urijs';
import { apiClient, isAxiosError } from './api-client';
import { PartSearchResultDetails } from '@/entities/PartSearchResultDetails';

/**
 * Service to retrieve parts.
 */
export class PartService {
    private get baseUrl(): URI {
        return new URI('/api/parts');
    }

    public async getAvailabilityOfPart(
        id: string,
        quantity: number,
        orderMethod?: string,
        respectPartReplacements?: boolean
    ): Promise<PartAvailability | null> {
        try {
            const res = await apiClient.get<PartAvailability>(
                this.baseUrl
                    .segmentCoded('availability')
                    .addQuery('partId', id)
                    .addQuery('quantity', quantity.toString(10))
                    .addQuery('orderMethod', orderMethod)
                    .addQuery('respectPartReplacements', respectPartReplacements)
                    .toString()
            );
            return res.data;
        } catch (error) {
            if (
                isAxiosError<PartAvailability>(error) &&
                error.response &&
                error.response.status === 404
            ) {
                return null;
            }
            throw error;
        }
    }
}
